import Vue from 'vue'

// Поддерживаем tree-shaking
import {
	LayoutPlugin,
	ButtonPlugin,
	FormCheckboxPlugin,
	ImagePlugin,
	FormInputPlugin,
	FormGroupPlugin,
	InputGroupPlugin,
} from 'bootstrap-vue'

Vue.use(LayoutPlugin)
Vue.use(ButtonPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(ImagePlugin)
Vue.use(FormInputPlugin)
Vue.use(FormGroupPlugin)
Vue.use(InputGroupPlugin)
